import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import AddProduct from "./pages/AddProduct";
import EditProfile from "./pages/EditProfile";
import Verify from "./pages/Verify";
import EditProduct from "./pages/EditProduct";
import Waiting from "./pages/Waiting";
import Admin from "./pages/Admin";

import { ProtectedRoute, PublicOnlyRoute } from "./menupro.guard";
import { AdminProtectedRoute } from "./menupro.admin.guard";
import AdminLogin from "./pages/AdminLogin";

export default function MenuProApp() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="login" />} />

      {/* Public */}
      <Route
        path="login"
        element={
          <PublicOnlyRoute>
            <Login />
          </PublicOnlyRoute>
        }
      />

      <Route
        path="register"
        element={
          <PublicOnlyRoute>
            <Register />
          </PublicOnlyRoute>
        }
      />

      <Route
        path="verify"
        element={
          <PublicOnlyRoute>
            <Verify />
          </PublicOnlyRoute>
        }
      />

      {/* Waiting */}
      <Route
        path="waiting/:phone"
        element={
          <PublicOnlyRoute>
            <Waiting />
          </PublicOnlyRoute>
        }
      />

      {/* User Protected */}
      <Route
        path="dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="add-product"
        element={
          <ProtectedRoute>
            <AddProduct />
          </ProtectedRoute>
        }
      />

      <Route
        path="profile"
        element={
          <ProtectedRoute>
            <EditProfile />
          </ProtectedRoute>
        }
      />

      <Route
        path="edit-product/:id"
        element={
          <ProtectedRoute>
            <EditProduct />
          </ProtectedRoute>
        }
      />

      <Route path="admin-login" element={<AdminLogin />} />

<Route
  path="admin"
  element={
    <AdminProtectedRoute>
      <Admin />
    </AdminProtectedRoute>
  }
/>

    </Routes>
  );
}

